import { FC, useState } from 'react'

import { Stepper as MantineStepper } from '@mantine/core'
import styled from 'styled-components'

import { Button } from 'src/Components/Button'

const StyledStepper = styled(MantineStepper)`
  width: 100%;
  .mantine-Stepper-content {
    padding-top: 40px;
  }

  .mantine-Stepper-steps {
    max-width: 1200px !important;
  }
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`

interface Step {
  title: string
  description?: string
  content: React.ReactNode
}

interface StepperProps {
  steps: Step[]
  onStepClick: (step: number) => void
  onFinish?: () => void
}

export const Stepper: FC<StepperProps> = ({ steps, onStepClick, onFinish }) => {
  const [active, setActive] = useState(0)
  const nextStep = (): void => {
    setActive((current) => (current < 3 ? current + 1 : current))
    onStepClick(active)
  }

  const prevStep = (): void =>
    setActive((current) => (current > 0 ? current - 1 : current))

  const isLastStep = active === steps.length - 1

  return (
    <>
      <StyledStepper active={active} onStepClick={setActive}>
        {steps.map((step, index) => (
          <MantineStepper.Step
            key={index}
            label={step.title}
            description={step.description}
          >
            {step.content}
          </MantineStepper.Step>
        ))}
      </StyledStepper>

      <ButtonsContainer>
        {active > 0 && <Button onClick={prevStep}>Назад</Button>}

        {isLastStep ? (
          <Button onClick={onFinish}>Создать контракт</Button>
        ) : (
          <Button onClick={nextStep}>Далее</Button>
        )}
      </ButtonsContainer>
    </>
  )
}
